import * as React from 'react'
import * as s from './Message.scss'
import cn from 'classnames'
import { moment } from 'features/Moment'

export interface IMessageProps {
  children: any
  /** Is this an other persons (user) message */
  other?: boolean
  /** Time the message was set */
  time: string
  /** Sender number */
  sender: string
}

export const Message = ({ children, other, time, sender }: IMessageProps) => (
  <div className={cn(s.outer, other ? s.other : s.me)} title={`Sent by ${sender}`}>
    <div>
      <div className={s.message}>{children}</div>
      <div className={s.timestamp}>{moment(time).fromNow()}</div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// src/features/Messages/Message/Message.tsx